import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Visuele breadcrumbs — combineer met `BreadcrumbJsonLd` voor schema.
 * items: [{name, url?}]  - laatste item heeft geen url (current page).
 */
export default function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumbs" className="font-modern text-xs text-ink-soft" data-testid="breadcrumbs">
      <ol className="flex items-center flex-wrap gap-1.5">
        <li>
          <Link to="/" className="inline-flex items-center gap-1 hover:text-ink transition-colors">
            <Home className="h-3 w-3" /> Home
          </Link>
        </li>
        {items.map((it, idx) => (
          <li key={idx} className="inline-flex items-center gap-1.5">
            <ChevronRight className="h-3 w-3 text-ink-subtle" />
            {it.url && idx < items.length - 1 ? (
              <Link to={it.url} className="hover:text-ink transition-colors">{it.name}</Link>
            ) : (
              <span aria-current="page" className="text-ink font-medium">{it.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
